<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Confirma que deseja deletar o território
              {{ payload.nomeFantasia }}?
            </h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Deletar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { territorioAPI } from "@/modules/gestao-territorios/API/territorioAPI";

export default {
  name: "AppModalDeleteTask",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      territorioAPI
        .delete(this.payload.territorioId)
        .then(() => {
          this.$notification.success("Território deletado com sucesso!");
          this.$emit("onDelete");
          this.dialog = false;
          this.setLoading(false);
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.data &&
            err.response.data.existeIniciativa
          ) {
            this.$notification.error(
              "Não é possível deletar o território, pois existem iniciativas vinculadas a ele"
            );
            this.dialog = false;
          } else {
            this.$notification.error("Erro ao deletar Território");
          }
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
